module.exports = __webpack_public_path__ + "img/four.ba010147.jpg";